// extracted by mini-css-extract-plugin
export default {"modal_body":"ModalCarregando_modal_body__uLfZV","backdrop_z_override":"ModalCarregando_backdrop_z_override__EcIVU"};